import Vue from 'vue';

export default {

  async fetchWeatherById({ commit }, id) {
    return Vue.axios.get(Vue.$url("dpr-weather/" + id))
      .then((rsp) => commit("SET_WEATHER", rsp.data))
  },

  async fetchWeatherEntries({ commit }, mainId) {
    return Vue.axios.get(Vue.$url("dpr-weather/all/" + mainId))
      .then((rsp) => commit("SET_WEATHER_ENTRIES", rsp.data))
  },

}